import React from 'react'
import { Button, Icon } from '@ally/metronome-ui'
import { muiClose } from '@ally/metronome-icons'

export interface DrawerProps {
  control: React.ReactElement
  className?: string
  children?: React.ReactNode
  isHidden: boolean
  onClose?: () => void
  closeLinkTagging?: string
}

const DumbDrawer: React.FC<DrawerProps> = function Drawer({
  control,
  children,
  className,
  isHidden,
  onClose,
  closeLinkTagging,
}) {
  return (
    <div className={className}>
      <div className="drawer-controls">{control}</div>
      <div className="drawer-content" hidden={isHidden}>
        {children}
        <Button
          variant="link"
          unsupportedContent={
            <span>
              <Icon icon={muiClose} size="sm" />
            </span>
          }
          onClick={onClose}
          aria-label="Close"
          withAllyTM={closeLinkTagging}
        />
      </div>
    </div>
  )
}

export { DumbDrawer }
